module.exports = __webpack_public_path__ + "static/media/_AMB8982-2.85e7d78c.jpg";